import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DonutLargeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"donut_large"}/>
}
